(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam-cart-completion"]) return;
  try {
    
(() => {
  const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
  const MELBOURNE_FULFILMENT = 'Melbourne Delivery';
  const INTERSTATE_FULFILMENT = 'Interstate Shipping';
  const toUtcDate = (iso) => new Date(`${iso}T00:00:00Z`);
  const toIso = (date) => date.toISOString().slice(0, 10);
  const addDays = (iso, days) => {
    const date = toUtcDate(iso);
    date.setUTCDate(date.getUTCDate() + days);
    return toIso(date);
  };

  const parseServerEpoch = (value) => {
    const normalized = String(value ?? '').trim();
    if (!/^\d+$/.test(normalized)) throw new Error('A valid Shopify server timestamp is required.');
    const milliseconds = Number(normalized) * 1000;
    const date = new Date(milliseconds);
    if (!Number.isFinite(milliseconds) || Number.isNaN(date.getTime())) {
      throw new Error('A valid Shopify server timestamp is required.');
    }
    return date;
  };

  const melbourneDateTimeFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Australia/Melbourne',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hourCycle: 'h23',
  });

  const getMelbourneDateTime = (now) => {
    const values = Object.fromEntries(
      melbourneDateTimeFormatter.formatToParts(now).map(({ type, value }) => [type, value]),
    );
    return {
      iso: `${values.year}-${values.month}-${values.day}`,
      hour: Number(values.hour),
    };
  };

  const getMelbourneIsoDate = (now = new Date()) => getMelbourneDateTime(now).iso;

  const getAvailabilityBaseIso = ({ now, cutoffHour }) => {
    const melbourne = getMelbourneDateTime(now);
    return melbourne.hour < cutoffHour ? melbourne.iso : addDays(melbourne.iso, 1);
  };

  const parseIso = (value) => {
    if (!ISO_DATE.test(value)) throw new Error(`Blackout dates must use YYYY-MM-DD: ${value}`);
    if (toIso(toUtcDate(value)) !== value) throw new Error(`Blackout dates must use YYYY-MM-DD: ${value}`);
    return value;
  };

  const parseConfiguration = ({ openWeekdays, blackoutDates, horizonDays, cutoffHour }) => {
    const weekdayTokens = String(openWeekdays)
      .split(',')
      .map((value) => value.trim());
    if (!weekdayTokens.length || weekdayTokens.some((value) => !/^[0-6]$/.test(value))) {
      throw new Error('Configure at least one valid open delivery day.');
    }
    const uniqueWeekdays = [...new Set(weekdayTokens.map(Number))];

    const blackouts = String(blackoutDates)
      .split(/\r?\n/)
      .map((value) => value.trim())
      .filter(Boolean)
      .map(parseIso);
    const normalizedHorizon = String(horizonDays).trim();
    const horizon = /^\d+$/.test(normalizedHorizon) ? Number(normalizedHorizon) : Number.NaN;
    if (!Number.isInteger(horizon) || horizon < 30 || horizon > 730) {
      throw new Error('Booking horizon must be between 30 and 730 days.');
    }
    const normalizedCutoff = String(cutoffHour ?? '').trim();
    const cutoff = /^\d+$/.test(normalizedCutoff) ? Number(normalizedCutoff) : Number.NaN;
    if (!Number.isInteger(cutoff) || cutoff < 0 || cutoff > 23) {
      throw new Error('Delivery cutoff hour must be a whole number from 0 to 23.');
    }
    return {
      openWeekdays: uniqueWeekdays,
      blackoutDates: [...new Set(blackouts)],
      horizonDays: horizon,
      cutoffHour: cutoff,
    };
  };

  const getCartLeadDays = (lines) => {
    if (!lines.length) return null;
    const leads = lines.map(({ leadDays }) => {
      const configured = leadDays == null ? '' : String(leadDays).trim();
      const normalized = configured === '' ? '0' : configured;
      return /^\d+$/.test(normalized) ? Number(normalized) : Number.NaN;
    });
    if (leads.some((value) => !Number.isInteger(value) || value < 0 || value > 90)) {
      throw new Error('Delivery lead times must be whole numbers from 0 to 90 days.');
    }
    return Math.max(...leads);
  };

  const buildAvailability = ({ baseIso, leadDays, openWeekdays, blackoutDates, horizonDays }) => {
    const open = new Set(openWeekdays);
    const blackouts = new Set(blackoutDates);
    const dates = [];
    let counted = 0;
    let earliestIso = null;
    for (let offset = 0; offset <= horizonDays; offset += 1) {
      const iso = addDays(baseIso, offset);
      if (!open.has(toUtcDate(iso).getUTCDay()) || blackouts.has(iso)) continue;
      if (counted < leadDays) {
        counted += 1;
        continue;
      }
      earliestIso ||= iso;
      dates.push(iso);
    }
    if (!earliestIso) throw new Error('No delivery date is available inside the booking horizon.');
    return { earliestIso, dates };
  };

  const formatSavedDate = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;

  const optionDateFormatters = new Map();
  const getOptionDateFormatter = (locale = 'en-AU') => {
    const displayLocale = /^en(?:-|$)/i.test(locale) ? 'en-AU' : locale;
    let formatter = optionDateFormatters.get(displayLocale);
    if (!formatter) {
      formatter = new Intl.DateTimeFormat(displayLocale, {
        timeZone: 'UTC',
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
      optionDateFormatters.set(displayLocale, formatter);
    }
    return formatter;
  };
  const formatOptionDate = (iso, locale = 'en-AU') => getOptionDateFormatter(locale).format(toUtcDate(iso));

  const savedDateToIso = (value) => {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    return match ? `${match[3]}-${match[2]}-${match[1]}` : '';
  };
  const isPersistedDateValid = (value, dates) => dates.includes(savedDateToIso(value));

  const getCartEligibility = (lines) => {
    if (lines.length === 0) return 'none';
    return lines.every(({ interstateEligible }) => interstateEligible === true)
      ? 'eligible-only'
      : 'melbourne-only';
  };

  const resolveFulfilmentSelection = ({ eligibility, currentMethod }) => {
    if (eligibility === 'none') return 'none';
    if (eligibility === 'melbourne-only') return 'melbourne';
    if (currentMethod === MELBOURNE_FULFILMENT) return 'melbourne';
    if (currentMethod === INTERSTATE_FULFILMENT) return 'interstate';
    return '';
  };

  const getCompletionState = ({
    blocked = false,
    requiresFulfilment = false,
    selectedFulfilment = '',
    savedFulfilment = '',
    requiresDate = false,
    selectedDate = '',
    savedDate = '',
    saving = false,
  }) => {
    if (blocked) return { action: 'blocked', canCheckout: false };
    if (requiresFulfilment && selectedFulfilment === '') {
      return { action: 'choose-fulfilment', canCheckout: false };
    }
    if (
      selectedFulfilment !== '' &&
      selectedFulfilment !== 'none' &&
      selectedFulfilment !== savedFulfilment
    ) {
      return { action: 'choose-fulfilment', canCheckout: false };
    }
    if (saving) {
      return { action: requiresDate ? 'choose-date' : 'checkout', canCheckout: false };
    }
    const canCheckout = !requiresDate || (selectedDate !== '' && selectedDate === savedDate);
    return { action: canCheckout ? 'checkout' : 'choose-date', canCheckout };
  };

  const reconcilePersistedDate = ({ value, dates, requiresDate }) => {
    const keep = requiresDate && value !== '' && isPersistedDateValid(value, dates);
    return { value: keep ? value : '', mustClear: value !== '' && !keep };
  };

  const createRequestGate = () => {
    let current = 0;
    return {
      begin: () => {
        current += 1;
        return current;
      },
      isCurrent: (sequence) => sequence === current,
    };
  };

  const saveCartAttributes = async ({
    url,
    attributes,
    signal,
    request = fetch,
    saveError = "We couldn't save your cart details.",
    confirmationError = "Shopify couldn't confirm your cart details.",
  }) => {
    const response = await request(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
      signal,
    });
    if (!response.ok) throw new Error(saveError);
    const cart = await response.json();
    for (const [name, value] of Object.entries(attributes)) {
      if ((cart.attributes?.[name] || '') !== value) throw new Error(confirmationError);
    }
    return cart;
  };

  const saveDeliveryDate = ({ url, value, signal, request = fetch }) =>
    saveCartAttributes({
      url,
      attributes: { 'Delivery Date': value },
      signal,
      request,
      saveError: "We couldn't save your delivery date.",
      confirmationError: "Shopify couldn't confirm your delivery date.",
    });

  class SamCartCompletion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.samReady === 'true') {
        this.bindFormGuard();
        return;
      }
      this.dataset.samReady = 'true';
      this.requestGate = createRequestGate();
      this.abortController = null;
      this.cacheElements();
      this.select.addEventListener('change', () => {
        this.selectedDate = this.select.value;
        this.updateState();
        this.pendingPersistence = this.persistSelectedDate(this.selectedDate, 'saved');
        return this.pendingPersistence;
      });
      for (const option of this.fulfilmentOptions) {
        option.addEventListener('change', () => {
          if (!option.checked) return null;
          this.pendingPersistence = this.changeFulfilment(option.value);
          return this.pendingPersistence;
        });
      }
      this.retry.addEventListener('click', () => {
        if (!this.retryAttributes) return null;
        this.pendingPersistence = this.persistCartAttributes(
          this.retryAttributes,
          this.retrySuccessStatus,
        );
        return this.pendingPersistence;
      });
      this.mobileAction.addEventListener('click', () => this.handleMobileAction());
      this.handleFormSubmit = (event) => {
        if (event.target?.id !== 'cart') return;
        this.handleCheckoutAction(event);
      };
      this.bindFormGuard();
      this.checkoutButton.addEventListener('click', (event) => this.handleCheckoutAction(event));
      this.initialize();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.ownerDocument.removeEventListener('submit', this.handleFormSubmit);
      this.formGuardConnected = false;
    }

    cacheElements() {
      this.fulfilmentField = this.querySelector('[data-sam-fulfilment-field]');
      this.fulfilmentOptions = [...this.querySelectorAll('[data-sam-fulfilment-option]')];
      this.incompatibility = this.querySelector('[data-sam-incompatibility]');
      this.dateField = this.querySelector('[data-sam-date-field]');
      this.datePicker = this.querySelector('[data-sam-date-picker]');
      this.select = this.querySelector('#SamDeliveryDate');
      this.status = this.querySelector('#SamDeliveryStatus');
      this.retry = this.querySelector('[data-sam-date-retry]');
      this.checkoutButton = this.querySelector('#checkout');
      this.actionLabel = this.querySelector('[data-sam-action-label]');
      this.mobileAction = this.querySelector('[data-sam-mobile-action]');
      this.fulfilmentLabel = this.querySelector('[data-sam-fulfilment-label]');
      this.reassurance = this.querySelector('[data-sam-reassurance]');
    }

    bindFormGuard() {
      if (this.formGuardConnected) return;
      this.ownerDocument.addEventListener('submit', this.handleFormSubmit);
      this.formGuardConnected = true;
    }

    initialize() {
      this.lines = [...this.querySelectorAll('[data-sam-delivery-line]')];
      this.cartEligibility = getCartEligibility(
        this.lines.map(({ dataset }) => ({
          interstateEligible: dataset.interstateEligible === 'true',
        })),
      );
      this.currentFulfilmentMethod = this.dataset.currentFulfilmentMethod || '';
      this.savedFulfilment =
        this.currentFulfilmentMethod === MELBOURNE_FULFILMENT
          ? 'melbourne'
          : this.currentFulfilmentMethod === INTERSTATE_FULFILMENT
            ? 'interstate'
            : '';
      this.selectedFulfilment = resolveFulfilmentSelection({
        eligibility: this.cartEligibility,
        currentMethod: this.currentFulfilmentMethod,
      });
      this.savedDate = this.dataset.currentDate || '';
      this.selectedDate = '';
      this.requiresDate = false;
      this.calendarBlocked = false;
      this.calendarReady = false;
      this.saving = false;
      this.persistenceFailed = false;
      this.fulfilmentField.hidden = this.cartEligibility !== 'eligible-only';
      this.incompatibility.hidden = this.cartEligibility !== 'melbourne-only';
      this.incompatibility.textContent = this.dataset.messageIncompatible;

      const attributes = {};
      if (this.cartEligibility === 'none') {
        if (this.savedDate !== '') attributes['Delivery Date'] = '';
        if (this.currentFulfilmentMethod !== '') attributes['Fulfilment Method'] = '';
      } else if (this.selectedFulfilment === 'melbourne') {
        const persisted = this.prepareMelbourne();
        if (persisted.mustClear) attributes['Delivery Date'] = '';
        if (this.currentFulfilmentMethod !== MELBOURNE_FULFILMENT) {
          attributes['Fulfilment Method'] = MELBOURNE_FULFILMENT;
        }
      } else {
        this.requiresDate = false;
        this.selectedDate = '';
        this.select.value = '';
        if (this.selectedFulfilment === 'interstate' && this.savedDate !== '') {
          attributes['Delivery Date'] = '';
        }
      }

      this.syncPresentation();
      this.updateState();
      if (Object.keys(attributes).length > 0) {
        this.pendingPersistence = this.persistCartAttributes(
          attributes,
          Object.hasOwn(attributes, 'Delivery Date') ? 'changed' : '',
        );
      }
    }

    prepareMelbourne() {
      this.requiresDate = true;
      this.calendarBlocked = false;
      this.calendarReady = false;
      if (this.dataset.enabled !== 'true') {
        this.calendarBlocked = true;
        this.setStatus('config-error');
        return { mustClear: false };
      }
      try {
        this.configuration = parseConfiguration({
          openWeekdays: this.dataset.openWeekdays,
          blackoutDates: this.dataset.blackoutDates,
          horizonDays: this.dataset.bookingHorizon,
          cutoffHour: this.dataset.cutoffHour,
        });
      } catch {
        this.calendarBlocked = true;
        this.setStatus('config-error');
        return { mustClear: false };
      }
      try {
        this.leadDays = getCartLeadDays(
          this.lines.map(({ dataset }) => ({ leadDays: dataset.leadDays })),
        );
      } catch {
        for (const line of this.lines) {
          try {
            getCartLeadDays([{ leadDays: line.dataset.leadDays }]);
          } catch {
            console.error(
              'Invalid delivery lead time configuration',
              line.dataset.productId,
              line.dataset.variantId,
            );
          }
        }
        this.calendarBlocked = true;
        this.setStatus('product-error');
        return { mustClear: false };
      }
      try {
        this.availability = buildAvailability({
          baseIso: this.getAvailabilityBaseIso(),
          leadDays: this.leadDays,
          ...this.configuration,
        });
      } catch {
        this.calendarBlocked = true;
        this.setStatus('no-dates');
        return { mustClear: false };
      }
      this.populateOptions(this.availability.dates);
      const persisted = reconcilePersistedDate({
        value: this.savedDate,
        dates: this.availability.dates,
        requiresDate: true,
      });
      this.savedDate = persisted.value;
      this.selectedDate = persisted.value;
      this.select.value = persisted.value;
      this.calendarReady = true;
      return persisted;
    }

    getAvailabilityBaseIso() {
      return getAvailabilityBaseIso({
        now: parseServerEpoch(this.dataset.serverEpoch),
        cutoffHour: this.configuration.cutoffHour,
      });
    }

    populateOptions(dates) {
      const prompt = this.select.children[0];
      this.select.replaceChildren(prompt);
      const locale = this.dataset.locale || 'en-AU';
      const monthFormatter = new Intl.DateTimeFormat(locale, {
        timeZone: 'UTC',
        month: 'long',
        year: 'numeric',
      });
      const groups = new Map();
      for (const iso of dates) {
        const monthKey = iso.slice(0, 7);
        let group = groups.get(monthKey);
        if (!group) {
          group = this.ownerDocument.createElement('optgroup');
          group.label = monthFormatter.format(toUtcDate(iso));
          groups.set(monthKey, group);
          this.select.append(group);
        }
        const option = this.ownerDocument.createElement('option');
        option.value = formatSavedDate(iso);
        option.textContent = formatOptionDate(iso, locale);
        group.append(option);
      }
    }

    syncPresentation() {
      for (const option of this.fulfilmentOptions) {
        option.checked =
          (option.value === MELBOURNE_FULFILMENT && this.selectedFulfilment === 'melbourne') ||
          (option.value === INTERSTATE_FULFILMENT && this.selectedFulfilment === 'interstate');
      }
      this.dateField.hidden = !this.requiresDate;
      this.datePicker.hidden = !this.requiresDate;
      this.select.required = this.requiresDate;
      this.syncControlAvailability();
      if (this.selectedFulfilment === 'interstate') {
        this.fulfilmentLabel.textContent = this.dataset.labelInterstate;
        this.reassurance.textContent = this.dataset.messageInterstate;
      } else if (this.selectedFulfilment === 'melbourne') {
        this.fulfilmentLabel.textContent = this.dataset.labelMelbourne;
        this.reassurance.textContent = this.dataset.messageSaved;
      } else if (this.cartEligibility === 'eligible-only') {
        this.fulfilmentLabel.textContent = this.dataset.messageChooseFulfilment;
        this.reassurance.textContent = this.dataset.messageChooseFulfilment;
      }
    }

    syncControlAvailability() {
      for (const option of this.fulfilmentOptions) {
        option.disabled = this.saving;
      }
      this.select.disabled =
        !this.requiresDate ||
        !this.calendarReady ||
        this.calendarBlocked ||
        this.saving ||
        this.savedFulfilment !== 'melbourne';
    }

    changeFulfilment(value) {
      const selection =
        value === MELBOURNE_FULFILMENT
          ? 'melbourne'
          : value === INTERSTATE_FULFILMENT
            ? 'interstate'
            : '';
      if (this.cartEligibility !== 'eligible-only' || selection === '') return Promise.resolve();

      this.selectedFulfilment = selection;
      this.setStatus('');
      const attributes = {
        'Fulfilment Method':
          selection === 'melbourne' ? MELBOURNE_FULFILMENT : INTERSTATE_FULFILMENT,
      };
      const leavingInterstate =
        selection === 'melbourne' &&
        (this.savedFulfilment === 'interstate' ||
          this.currentFulfilmentMethod === INTERSTATE_FULFILMENT);
      if (selection === 'melbourne') {
        if (leavingInterstate) {
          this.savedDate = '';
          this.selectedDate = '';
          this.select.value = '';
          attributes['Delivery Date'] = '';
        }
        const persisted = this.prepareMelbourne();
        if (persisted.mustClear) attributes['Delivery Date'] = '';
      } else {
        this.requiresDate = false;
        this.calendarBlocked = false;
        this.selectedDate = '';
        this.select.value = '';
        attributes['Delivery Date'] = '';
      }
      this.syncPresentation();
      this.updateState();
      return this.persistCartAttributes(attributes);
    }
    getState() {
      return getCompletionState({
        blocked: this.calendarBlocked || this.persistenceFailed,
        requiresFulfilment: this.cartEligibility === 'eligible-only',
        selectedFulfilment: this.selectedFulfilment,
        savedFulfilment: this.savedFulfilment,
        requiresDate: this.requiresDate,
        selectedDate: this.selectedDate,
        savedDate: this.savedDate,
        saving: this.saving,
      });
    }

    promptForCompletion(state) {
      if (state.action === 'blocked') {
        if (this.persistenceFailed && !this.retry.hidden) this.retry.focus();
        return;
      }
      if (state.action === 'choose-fulfilment') {
        if (this.selectedFulfilment === '') {
          this.setStatus('fulfilment-required');
          this.fulfilmentOptions[0]?.focus();
        }
        return;
      }
      if (this.requiresDate && !this.select.disabled && this.selectedDate === '') {
        this.setStatus('required-error');
      }
      this.select.focus();
    }

    handleCheckoutAction(event) {
      const state = this.getState();
      if (state.canCheckout) return;
      event.preventDefault();
      this.promptForCompletion(state);
    }

    handleMobileAction() {
      const state = this.getState();
      if (!state.canCheckout) {
        this.promptForCompletion(state);
        return;
      }
      this.ownerDocument.querySelector('form#cart')?.requestSubmit(this.checkoutButton);
    }

    updateState() {
      const state = this.getState();
      const canPromptFulfilment =
        state.action === 'choose-fulfilment' &&
        this.selectedFulfilment === '' &&
        !this.saving;
      const canChooseDate =
        state.action === 'choose-date' &&
        this.requiresDate &&
        !this.select.disabled &&
        !this.saving;
      const actionEnabled = state.canCheckout || canPromptFulfilment || canChooseDate;
      this.checkoutButton.disabled = !actionEnabled;
      this.mobileAction.disabled = !actionEnabled;
      const label =
        state.action === 'blocked'
          ? this.dataset.actionReview
          : state.action === 'checkout'
            ? this.dataset.actionCheckout
            : state.action === 'choose-fulfilment'
              ? this.dataset.actionChooseFulfilment
              : this.dataset.actionChoose;
      this.actionLabel.textContent = label;
      this.mobileAction.textContent = label;
    }

    setSaving(saving) {
      this.saving = saving;
      if (saving) this.setStatus('saving');
      this.syncControlAvailability();
      this.updateState();
    }

    setStatus(status) {
      const messages = {
        changed: this.dataset.messageChanged,
        'config-error': this.dataset.messageConfigError,
        'fulfilment-required': this.dataset.messageChooseFulfilment,
        'no-dates': this.dataset.messageNoDates,
        'product-error': this.dataset.messageProductError,
        'required-error': this.dataset.messageRequired,
        'save-error': this.dataset.messageSaveError,
        saved: this.dataset.messageSaved,
        saving: this.dataset.messageSaving,
      };
      const assertive = status === 'required-error' || status === 'fulfilment-required';
      this.status.setAttribute('role', assertive ? 'alert' : 'status');
      this.status.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
      this.status.textContent = messages[status] || '';
      this.status.classList.toggle('visually-hidden', status === 'saved' || status === 'saving');
      this.retry.hidden = status !== 'save-error';
    }

    persistSelectedDate(value, successStatus = '') {
      return this.persistCartAttributes({ 'Delivery Date': value }, successStatus);
    }

    async persistCartAttributes(attributes, successStatus = '') {
      this.abortController?.abort();
      this.persistenceFailed = false;
      this.abortController = new AbortController();
      const sequence = this.requestGate.begin();
      this.retryAttributes = { ...attributes };
      this.retrySuccessStatus = successStatus;
      this.setSaving(true);
      try {
        await saveCartAttributes({
          url: this.dataset.cartUpdateUrl,
          attributes,
          signal: this.abortController.signal,
        });
        if (!this.requestGate.isCurrent(sequence)) return;
        if (Object.hasOwn(attributes, 'Delivery Date')) {
          this.savedDate = attributes['Delivery Date'];
        }
        if (Object.hasOwn(attributes, 'Fulfilment Method')) {
          this.currentFulfilmentMethod = attributes['Fulfilment Method'];
          this.savedFulfilment =
            attributes['Fulfilment Method'] === MELBOURNE_FULFILMENT
              ? 'melbourne'
              : attributes['Fulfilment Method'] === INTERSTATE_FULFILMENT
                ? 'interstate'
                : '';
        }
        this.persistenceFailed = false;
        this.retryAttributes = null;
        this.retrySuccessStatus = '';
        this.setStatus(successStatus);
      } catch (error) {
        if (error.name === 'AbortError' || !this.requestGate.isCurrent(sequence)) return;
        this.persistenceFailed = true;
        this.setStatus('save-error');
      } finally {
        if (this.requestGate.isCurrent(sequence)) this.setSaving(false);
      }
    }
  }

  if (!customElements.get('sam-cart-completion')) {
    customElements.define('sam-cart-completion', SamCartCompletion);
  }
  window.SamCartDeliveryRules = Object.freeze({
    parseServerEpoch,
    getMelbourneIsoDate,
    getAvailabilityBaseIso,
    parseConfiguration,
    getCartLeadDays,
    buildAvailability,
    formatSavedDate,
    formatOptionDate,
    isPersistedDateValid,
    getCompletionState,
    getCartEligibility,
    resolveFulfilmentSelection,
    reconcilePersistedDate,
    createRequestGate,
    saveDeliveryDate,
  });
})();

  } catch(e) { console.error(e); }
})();
})();
